<template>
  <div class="notification-settings">
    <div class="notification-setting" v-for="(n, index) in notifications" :key="index">
      <select v-model="n.type" class="select">
        <option value="popup">Pop-up</option>
        <option value="email">E-mail</option>
      </select>

      <input type="number" min="0" v-model.number="n.time" class="input number-input" placeholder="Tempo" />

      <select v-model="n.unit" class="select title">
        <option value="minutes">Minutos</option>
        <option value="hours">Horas</option>
        <option value="days">Dias</option>
      </select>

      <button @click="remove(index)" class="btn btn-remove" title="Remover">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <button @click="add" class="btn btn-add">+ Adicionar notificação</button>
  </div>
</template>

<script>
export default {
  name: "NotificationSettings",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      notifications: [],
    };
  },
  created() {
    this.notifications = this.value;
  },
  watch: {
    notifications: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
        this.notifications = this.value;
      },
    },
    value: {
      deep: true,
      handler(val) {
       
      },
    },
  },
  methods: {
    add() {
      this.notifications.push({
        type: "popup",
        time: 10,
        unit: "minutes",
      });
    },
    remove(index) {
      this.notifications.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.notification-settings {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 600px;
}

.notification-setting {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.input {
  padding: 5px 10px;
  border: 1px solid #E1E1E2;
  border-radius: 12px;
  font-size: 14px;
  outline: none;
}

.select {
  min-width: 200px;
  padding: 8px 10px;
  border: 1px solid #E1E1E2;
  border-radius: 12px;
  font-size: 14px;
  outline: none;
}

.select option {
  background-color: #f9f9f9;
  border: none;
}

.number-input {
  width: 70px;
}

.btn {
  font-size: 14px;
  padding: 6px 12px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-add {
  background-color: #4caf50;
  color: white;
  width: 200px;
}

.btn-add:hover {
  background-color: #43a047;
}

.btn-remove {
  background-color: #e53935;
  color: white;
}

.btn-remove:hover {
  background-color: #c62828;
}
</style>
